import { render, staticRenderFns } from "./KeldiKetdi.vue?vue&type=template&id=19d4e2c2&scoped=true"
import script from "./KeldiKetdi.vue?vue&type=script&lang=js"
export * from "./KeldiKetdi.vue?vue&type=script&lang=js"
import style0 from "./KeldiKetdi.vue?vue&type=style&index=0&id=19d4e2c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d4e2c2",
  null
  
)

export default component.exports